module.exports = __webpack_public_path__ + "img/sol_cap1.9f10c02c.png";